export default "__VITE_ASSET__d35d4553__"